import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from '../../theme';
import useTextInputStyles from './TextInput.Styles';
import { SuccessIcon, ErrorIcon, BlockIcon } from '../../icons';
import { useState } from 'react';
export const DefaultProps = {
    disabled: false,
    fullWidth: true,
    error: false,
    validated: false
};
export const TextInput = ({ width, label, hint, disabled, fullWidth, error, validated, sx, ...props }) => {
    const theme = useTheme();
    const styles = useTextInputStyles({
        ...{
            hint,
            width,
            fullWidth,
            error,
            validated,
            disabled,
            label,
            ...props
        },
        theme
    });
    const [focus, setFocus] = useState(false);
    if (error && validated) {
        console.warn('TextInput: Warning! error and validated props are mutually exclusive');
    }
    return (_jsxs("label", { className: styles.container, style: sx, children: [label && _jsx("label", { className: `${styles.label}`, children: label }), _jsxs("div", { className: styles.inputContainer, children: [_jsxs("i", { children: [validated && _jsx(SuccessIcon, { className: styles.icons }), error && _jsx(ErrorIcon, { className: styles.icons }), disabled && _jsx(BlockIcon, { className: styles.icons })] }), _jsx("input", { className: `${styles.base} ${error ? styles.error : ''} ${validated ? styles.validated : ''} ${disabled ? styles.disabled : ''}`, type: "text", onFocus: () => setFocus(!focus), onBlur: () => setFocus(!focus), disabled: disabled, ...props })] }), hint && _jsx("span", { className: styles.hint, children: hint })] }));
};
export default TextInput;
